(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyWizardStepController', CompanyWizardStepController);

    CompanyWizardStepController.$inject = ['$uibModalInstance', '$window', 'AlertToastService', '__config', 'entity', 'CompanyCustom', '$state'];

    function CompanyWizardStepController($uibModalInstance, $window, AlertToastService, __config, entity, CompanyCustom, $state) {
        var vm = this;
        vm.type = "UNKNOWN";
        if (entity && entity.wizardStepType)
            vm.type = entity.wizardStepType;
        if (entity && entity.activityTypeInfo)
            vm.activityTypeInfo = entity.activityTypeInfo;

        vm.closeModal = closeModal;
        vm.okModal = okModal;
        vm.__config = __config;
        vm.buttonText = "بستن";
        vm.title = "";
        vm.state = "dashboard";
        vm.canCancel = false;
        vm.cancel = cancel;
        vm.isWorkingSpace = false;

        if (vm.activityTypeInfo.servantType == 'RESOURCE')
            vm.isWorkingSpace = true;


        loadPage();

        function loadPage() {
            initDefault();
        }

        function closeModal() {
            $uibModalInstance.dismiss('cancel');
        }

        function initDefault() {
            switch (vm.type) {
                case "ADD_SERVICE":
                    vm.buttonText = "ایجاد خدمت جدید";
                    vm.cancelButtonText = "متوجه شدم";
                    vm.title = "خدمات";
                    vm.state = "supplierPanel-v2.dashboard.newServiceItem";
                    vm.canCancel = true;
                    break;
                case "ADD_SERVANT":
                    if (!vm.isWorkingSpace) {
                        vm.buttonText = "ایجاد پرسنل جدید";
                        vm.cancelButtonText = "متوجه شدم";
                        vm.title = "پرسنل";
                    } else {
                        vm.buttonText = "ایجاد منابع(" + vm.activityTypeInfo.servantTitle + ") جدید";
                        vm.cancelButtonText = "متوجه شدم";
                        vm.title = "منابع";
                    }

                    vm.state = "supplierPanel-v2.dashboard.newCompanyServant";
                    vm.canCancel = true;
                    break;
                case "CHANGE_COMPANY_SCHEDULE":
                    vm.buttonText = "تنظیم ساعت کاری";
                    vm.cancelButtonText = "متوجه شدم";
                    vm.title = "ساعت کاری";
                    vm.state = "supplierPanel-v2.dashboard.companyWorkingTimes";
                    vm.canCancel = true;
                    break;
                case "CHANGE_THEME":
                    vm.buttonText = "تنظیم تصویر و لوگو";
                    vm.cancelButtonText = "متوجه شدم";
                    vm.title = "تصویر و لوگو";
                    vm.state = "supplierPanel-v2.dashboard.companySettingInfo";
                    vm.canCancel = true;
                    break;
                case "CONNECT_INSTAGRAM":
                    vm.buttonText = "متوجه شدم";
                    vm.title = "اینستاگرام";
                    vm.state = "supplierPanel-v2.dashboard";
                    vm.canCancel = false;
                    break;
                case "ADD_RESERVE":
                    vm.buttonText = "ثبت رزرو جدید";
                    vm.cancelButtonText = "متوجه شدم";
                    vm.title = "رزرو جدید";
                    vm.state = "supplierPanel-v2.dashboard.newReserve"
                    vm.canCancel = true;
                    break;
                default:
                    vm.buttonText = "بستن ";
                    vm.title = "نامشخص";
                    break;

            }
        }

        function okModal() {
            setStepDone(vm.type);
        }

        function setStepDone(type) {
            var wizardStep = {};
            if (type) {
                wizardStep.wizardStepType = type;
                CompanyCustom.setCompanyWizardStepsDone().save(wizardStep, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            if (vm.isCanceling) {
                $uibModalInstance.close(vm.type);
                vm.isCanceling = false;
                return;
            }

            if (vm.type != "CHANGE_THEME")
                $state.go(vm.state);
            else
                $state.go(vm.state, {settingFormSection: 'themeSettingTab'});

            $uibModalInstance.close(vm.type);
        }

        function onSaveError(error) {
            if (vm.type != "CHANGE_THEME")
                $state.go(vm.state);
            else
                $state.go(vm.state, {settingFormSection: 'themeSettingTab'});

            closeModal();
        }


        function cancel() {
            vm.isCanceling = true;
            setStepDone(vm.type);
        }


    }
})();
